import CompaniesComponent from '../CompaniesComponent.vue'
import CompanyDetailsComponent from '../CompanyDetailsComponent.vue'

export default [
    {
        path: '/companies',
        name: 'Companies',
        // Access is enforced by the component: Super Admin sees every company,
        // a company manager only the companies they manage.
        meta: { layout: 'default', requiresAuth: true },
        component: CompaniesComponent,
    },
    {
        path: '/companies/:id',
        name: 'CompanyDetails',
        meta: { layout: 'default', requiresAuth: true },
        component: CompanyDetailsComponent,
    },
]
